import { Controller } from "@hotwired/stimulus"

const SPINNER_FADE_DURATION = 300

export default class extends Controller {
  static targets = ["spinner", "content"]

  connect() {
    this.spinnerDismissed = false
    requestAnimationFrame(() => this.hideSpinner())
  }

  disconnect() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
  }

  hideSpinner() {
    if (!this.hasSpinnerTarget || this.spinnerDismissed) return

    this.spinnerDismissed = true
    this.spinnerTarget.classList.add("opacity-0", "pointer-events-none")
    this.hideTimeout = window.setTimeout(() => {
      this.spinnerTarget.classList.add("hidden")
    }, SPINNER_FADE_DURATION)
  }
}
